import GetFacilityTypesJSON from 'app/assets/jsons/FacilityType.json';

export function GetFacilityTypes() {
  const data = GetFacilityTypesJSON.facilityTypes;
  return data;
}
